
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_117_526)"}},[_c('path',{attrs:{"d":"M7.5 8.5l3 3 3-3","stroke":"currentColor","stroke-width":"1.3","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_117_526"}},[_c('path',{attrs:{"fill":"#fff","transform":"rotate(90 4.5 10.5)","d":"M0 0h8v9H0z"}})])])])
          )
        }
      }
    